import { render } from "./Privacy-policy-page.vue?vue&type=template&id=dfbef91a"
import script from "./Privacy-policy-page.vue?vue&type=script&lang=js"
export * from "./Privacy-policy-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__